import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';
import { ConfigService } from '@services/webFeeder/config.service';

@Injectable({ providedIn: 'root' })
export class OnboardingViewGuard  {

  constructor(
    private _router: Router,
    private _config: ConfigService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // TODO: Implementar regra de bloqueio de acesso a tela de onboarding caso seja necessario
  }

}
